'use client'

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

const NotImplementedErrorMsg = 'Function not implemented'

const DownloadPanelContext = createContext<{
  showDownloadSlidePanel: boolean
  toggleDownloadSlidePanel: () => void
}>({
  showDownloadSlidePanel: false,
  toggleDownloadSlidePanel: (): void => {
    throw new Error(NotImplementedErrorMsg)
  },
})

export const useDownloadPanelContext = () => useContext(DownloadPanelContext)

export const DownloadPanelContextProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [showDownloadSlidePanel, setShowDownloadSlidePanel] =
    useState<boolean>(false)

  const toggleDownloadSlidePanel = useCallback(() => {
    setShowDownloadSlidePanel((prev) => !prev)
  }, [])

  const downloadPanelContextValue = useMemo(
    () => ({
      showDownloadSlidePanel,
      toggleDownloadSlidePanel,
    }),
    [showDownloadSlidePanel, toggleDownloadSlidePanel],
  )

  return (
    <DownloadPanelContext.Provider value={downloadPanelContextValue}>
      {children}
    </DownloadPanelContext.Provider>
  )
}
